import {
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Select as USelect,
} from "@/components/ui/select";

interface SelectProps {
  value: string;
  width?: string;
  options: {
    label: string;
    value: string;
  }[];
  placeholder?: string;
  className?: string;
  onChange: (value: string) => void;
}

function Select({
  value,
  placeholder,
  className,
  width,
  options,
  onChange,
}: SelectProps) {
  return (
    <USelect value={value} onValueChange={onChange}>
      <SelectTrigger
        placeholder={placeholder}
        style={{ width, minWidth: width }}
        className={className}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {options.map((item) => (
            <SelectItem key={item.value} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </USelect>
  );
}

export default Select;
